<template>
  <l-modal
    :title="t('ordering.rename-tab')"
    size="small"
    :button-text="t('ctas.save')"
    :disabled="!isValid"
    @action="handleSave"
    @close="$emit('close')"
  >
    <l-input v-model="tabName" :placeholder="t('ordering.rename-tab-placeholder')" />
  </l-modal>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LInput, LModal } from '@last/core-ui/paprika'

import { useTabsStore } from '@/store/tabs'
import type { Tab } from '@/types'

type Props = {
  tab: Tab
}

const props = defineProps<Props>()
const emit = defineEmits<{
  close: []
}>()

const { t } = useI18n()
const tabsStore = useTabsStore()
const tabName = ref(props.tab.name || '')

const isValid = computed(() => tabName.value.trim().length > 0)

function handleSave() {
  if (!isValid.value) return

  tabsStore.renameTab({
    tabId: props.tab.id,
    name: tabName.value.trim()
  })

  emit('close')
}
</script>
